import React, { useState } from 'react'
import { Navigate } from 'react-router-dom'

import { platforms } from '../../constants'
import { platform_data } from '../../gameData'
import './Home.css'
const Home = () => {
  const [platformSelected, setPlatformSelected] = useState(false);
  const [pId, setPId] = useState();

  const onPlatformSelected = (slug) => {
    platform_data.forEach((data) => {
      if(data.slug === slug)
        setPId(data.id)
    })
    setPlatformSelected(true)
  }

  const platform_list = []
  
  for (let [key, value] of Object.entries(platforms.platforms)) {
    platform_list.push(<div key={key} onClick={() => onPlatformSelected(key)} className='platforms-platform'>{value}<span className='platforms-selected'>{key}</span></div>)
  }
  
  return (
    <div className='home'>
      <h2>Overwhelmed by the sheer number of games available today?</h2>
      <p> Select a platform below or check out the lists from the sidebar to browse games.</p>
      {platformSelected && <Navigate  to={`/platform/${pId}`} />}
      <div className='home-platforms'>
        { platform_list }
      </div>
    </div>
  )
}


export default Home